import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  ActiveInactiveItineraryFacility,
  deleteItineraryFacility,
  getAllItineraryFacility,
} from "./services/itineraryfacility.services";
import {
  clearItinearyFacilityID,
  setItinearyFacilityID,
} from "./itineraryfacilitySlice";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import LinkEdit from "../../components/drawer/LinkEdit";

const ItineraryFacility: React.FC = () => {
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllItineraryFacility());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  // const handleCreate = () => {
  //   navigate("/itineraryfacility/create");
  // };

  return (
    <>
      <DeleteItineraryFacilityDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Itinerary Facility List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate label="Add New" drawerName="itineraryFacilityForm" />
          )}
          {/* {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New"}
            </Button>
          )} */}
        </GridLayoutItem>
        <GridLayoutItem>
          <ItineraryFacilityGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const ItineraryFacilityGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const ItinearyFacilityList = useAppSelector(
    (state) => state.itinearyfacility.ItinearyFacilityList
  );
  const loading = useAppSelector((state) => state.itinearyfacility.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? ItinearyFacilityList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteItineraryFacility"));
      dispatch(setItinearyFacilityID(ID));
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {/* {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => handleEdit(props.dataItem.ID)}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )} */}
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.ID}
            drawerName="itineraryFacilityForm"
            tooltipTitle="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveItineraryFacility(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllItineraryFacility());
        } else {
          dispatch(getAllItineraryFacility());
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {ItinearyFacilityList && ItinearyFacilityList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          className="responsive-table"
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(ItinearyFacilityList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : ItinearyFacilityList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={ItinearyFacilityList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Name"
            title="Itinerary Facility"
            cells={{
              data: (props: any) => (
                <td
                  className={`${isEditAccess ? "hoverableName" : "normalName"}`}
                >
                  {isEditAccess ? (
                    <LinkEdit
                      ID={props.dataItem.ID}
                      drawerName="itineraryFacilityForm"
                      tooltipTitle="Update Itinerary Facility"
                      label={props.dataItem?.Name}
                    />
                  ) : (
                    props.dataItem?.Name
                  )}
                </td>
              ),
            }}
            // cell={(props: any) => (
            //   <td className="hoverableName">
            //     {isEditAccess ? (
            //       <div
            //         className="hoverableName"
            //         onClick={() =>
            //           navigate("/itineraryfacility/edit", {
            //             state: { ItineraryFacilityID: props.dataItem.ID },
            //           })
            //         }
            //       >
            //         {props.dataItem?.Name}
            //       </div>
            //     ) : (
            //       <div className="normalName">{props.dataItem?.Name}</div>
            //     )}
            //   </td>
            // )}
          />

          <Column
            field="ID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteItineraryFacilityDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const ItineraryFacilityID = useAppSelector(
    (state) => state.itinearyfacility.ItineraryFacilityID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteItineraryFacility(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(getAllItineraryFacility());
        dispatch(closeDialog());
        dispatch(clearItinearyFacilityID());
      } else {
        dispatch(getAllItineraryFacility());
        dispatch(closeDialog());
        dispatch(clearItinearyFacilityID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteItineraryFacility" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Itinerary Facility"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Itinerary Facility ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ItineraryFacilityID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default ItineraryFacility;
